import Api from  "@/services/AxiosAPI";

export default {
    getContactInfo() {
      return Api.getData('websiteContacts')
        .then(responses => {
          return responses
        });
    },
}